module.exports = __webpack_public_path__ + "img/JohnBowman_140x140.2f2a3211.jpg";